module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousDash
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Reports")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-2",
      modifiers: {
        "collapse-2": true
      }
    }],
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_vm._v("Filters")]), _vm._v(" "), _c('b-dropdown', {
    staticClass: "m-2 pull-right",
    attrs: {
      "size": "sm",
      "dropleft": "",
      "variant": "outline-dark",
      "text": "Export"
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": _vm.onDownloadPDF
    }
  }, [_vm._v("Export as PDF")]), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": _vm.onDownloadExcel
    }
  }, [_vm._v("Export as Excel")])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    }
  }, [_c('b-card', {
    staticClass: "gutr"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "isDisabled": _vm.clientType == '2',
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientId),
      callback: function($$v) {
        _vm.clientId = $$v
      },
      expression: "clientId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.viewFFExportFCL('0', '1')
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-header pull-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('date-picker', {
    staticClass: "pull-right",
    attrs: {
      "range": "",
      "lang": _vm.langEnq,
      "format": "YYYY-MM-DD",
      "confirm": ""
    },
    on: {
      "input": _vm.onConfirmDateRangeEq
    },
    model: {
      value: (_vm.dateRangeEnq),
      callback: function($$v) {
        _vm.dateRangeEnq = $$v
      },
      expression: "dateRangeEnq"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "mainEnquiryId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainEnquirySeries",
      fn: function(row1) {
        return [_c('span', [_vm._v("Enquiry No. : " + _vm._s(row1.item.mainEnquirySeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                  Enquiry Type : " + _vm._s(row1.item.jobType) + " -\n                  " + _vm._s(row1.item.shipmentType == "1" ? "Sea" : "Air") + "\n                  " + _vm._s(row1.item.transportType) + "\n                  "), _c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" ?
          "directions_boat" :
          "flight_takeoff"))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (
          row1.item.multipleContainerType != '' &&
          row1.item.multipleContainerType != null
        ) ? _c('span', [_vm._v("\n                  Container Type : " + _vm._s(row1.item.multipleContainerType) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.pickup != '' && row1.item.pickup != null) ? _c('span', [_vm._v("\n                  Pickup : " + _vm._s(row1.item.pickup) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.stuffingLoc != '' &&
          row1.item.stuffingLoc != null
        ) ? _c('span', [_vm._v("\n                  Stuffing : " + _vm._s(row1.item.stuffingLoc) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.handover != '' && row1.item.handover != null
        ) ? _c('span', [_vm._v("\n                  Handover : " + _vm._s(row1.item.handover) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.POR != '' && row1.item.POR != null) ? _c('span', [_vm._v("\n                  Place of Receipt : " + _vm._s(row1.item.POR) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.jobType.split(',').includes('FF')) ? _c('div', [(row1.item.LP != '' && row1.item.LP != null) ? _c('span', [_vm._v("\n                    Load Port : " + _vm._s(row1.item.LP) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.POD != '' && row1.item.POD != null) ? _c('span', [_vm._v("\n                    Port of Discharge : " + _vm._s(row1.item.POD) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.finalPlace != '' &&
          row1.item.finalPlace != null
        ) ? _c('span', [_vm._v("\n                    Final Place of Delivery : " + _vm._s(row1.item.finalPlace) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.departAirport != '' &&
          row1.item.departAirport != null
        ) ? _c('span', [_vm._v("\n                    Departure Airport : " + _vm._s(row1.item.departAirport) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (
          row1.item.destiAirport != '' &&
          row1.item.destiAirport != null
        ) ? _c('span', [_vm._v("\n                    Destination Airport : " + _vm._s(row1.item.destiAirport) + "\n                    "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Enquiry Date : " + _vm._s(_vm._f("moment")(row1.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.EmpLoc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised By : " + _vm._s(row1.item.employeeName))])]
      }
    }, {
      key: "clientName",
      fn: function(row11) {
        return [_c('b', [_vm._v("\n                  " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]), _vm._v(" "), (row11.item.clientType == '2') ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("Lead")])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    staticClass: "mt-4 pull-right",
    attrs: {
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows,
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3879796c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboardReportsDetails.vue
// module id = 2526
// module chunks = 0